const { importAllocations, resetAllocationsImport } = require('./import-allocations')

class TransactionApi {
  constructor (state, mainApi, restApi) {
    this.state = state
    this.mainApi = mainApi
    this.restApi = restApi
  }

  async importAllocations (checkpoint) {
    const db = this.state.allocationsDB
    return importAllocations(this.restApi, db, checkpoint)
  }

  async resetAllocationsImport (checkpoint) {
    const db = this.state.allocationsDB
    return resetAllocationsImport(db, checkpoint)
  }
}

module.exports = TransactionApi
